export default __webpack_public_path__ + "static/media/reports-v2.4ba9336e.svg";